export const easyMatchKeys = {
	all: ["easy-match"] as const,
	status: (userId: number) => [...easyMatchKeys.all, "status", userId] as const,
	searchCheck: (userId: number) =>
		[...easyMatchKeys.all, "search-check", userId] as const,
	action: (userRelationshipId: number) =>
		[...easyMatchKeys.all, "action", userRelationshipId] as const,
} as const
